import React, { useEffect, useState } from "react";
import { useIsFetching } from "react-query";

export const ScrollToElementById: React.FC<{
  container: HTMLElement | Document | null;
  id?: string;
}> = ({ container, id }) => {
  const isFetching = useIsFetching();
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    if (id && container !== null && !isFetching && !scrolled) {
      const elem = container.querySelector(`[id="${id}"]`);
      if (elem) {
        elem.scrollIntoView({ behavior: "smooth" });
        setScrolled(true);
      }
    }
  }, [container, id, isFetching, scrolled]);
  return null;
};
